import { CustomerAuthApiError } from '../customerAuthApi'
import { CustomerOrdersApiError } from '../customerOrdersApi'
import { CustomerSupportApiError } from '../customerSupportApi'

export const asAuthErrorMessage = (error: unknown) => {
  if (error instanceof CustomerAuthApiError) return error.message
  if (error instanceof Error && error.message.trim()) return error.message
  return 'Non siamo riusciti a creare l account. Riprova tra qualche secondo.'
}

export const asOrderErrorMessage = (error: unknown) => {
  if (error instanceof CustomerOrdersApiError) return error.message
  if (error instanceof Error && error.message.trim()) return error.message
  return 'Errore caricamento ordini cliente'
}

export const asSupportErrorMessage = (error: unknown) => {
  if (error instanceof CustomerSupportApiError) return error.message
  if (error instanceof Error && error.message.trim()) return error.message
  return 'Errore gestione richieste assistenza'
}
